import { atom } from '@reatom/framework'

import { selectedNetworkAtom } from '@root/entities/network'
import { WalletId } from '@root/entities/wallet'
import { reatomLimitOrders } from '@root/features/trade/limit-orders'
import { tradingWalletIdAtom } from '@root/features/trade/trading/atoms/trading-wallet'

import type { LimitOrder } from '@root/entities/limit-order'
import type { Network } from '@root/entities/network'
import type { ReatomLimitOrders } from '@root/features/trade/limit-orders'

const cache = new Map<string, ReatomLimitOrders>()
const createCacheKey = (
  network: Network.Network,
  status: LimitOrder.Status | undefined,
  type: LimitOrder.Type | 'all',
) => {
  return `${network}_${status ?? 'all'}_${type}`
}

export const orderStatusAtom = atom<LimitOrder.Status | undefined>(
  'active',
  'orderStatusAtom',
)
export const orderTypeAtom = atom<'all' | LimitOrder.Type>(
  'all',
  'orderTypeAtom',
)

export const tradingOrdersModelAtom = atom((ctx) => {
  const network = ctx.spy(selectedNetworkAtom)
  const walletId = ctx.spy(tradingWalletIdAtom) ?? WalletId('')
  const status = ctx.spy(orderStatusAtom)
  const type = ctx.spy(orderTypeAtom)

  const key = createCacheKey(network, status, type)
  const cached = cache.get(key)
  if (cached) {
    return cached
  }

  // eslint-disable-next-line @reatom/unit-naming-rule
  const model = reatomLimitOrders({
    network,
    walletId,
    status,
    type: type === 'all' ? undefined : type,
  })
  cache.set(key, model)

  return model
}, 'tradingOrdersModelAtom')

tradingWalletIdAtom.onChange(() => {
  cache.clear()
})
